import Box from '@mui/material/Box';

interface MeterBarProps {
  /** Lățimea umpluturii, deja formatată ca procent (ex. `"64%"`). */
  width: string;
  height?: number;
  /** `ink` pentru indicatorii de sistem, `accent` pentru mărimile meteo. */
  tone?: 'ink' | 'accent';
}

/**
 * Bară de nivel, pur decorativă: valoarea numerică e deja în DOM ca text lângă
 * fiecare bară, deci o ascundem de cititoarele de ecran în loc să o dublăm.
 */
export function MeterBar({ width, height = 6, tone = 'ink' }: MeterBarProps) {
  return (
    <Box
      aria-hidden
      sx={(theme) => ({
        height,
        borderRadius: `${theme.radii.pill}px`,
        backgroundColor: theme.palette.weather.line,
        overflow: 'hidden',
      })}
    >
      <Box
        sx={(theme) => ({
          height: '100%',
          width,
          borderRadius: `${theme.radii.pill}px`,
          backgroundColor:
            tone === 'accent' ? theme.palette.weather.accent : theme.palette.weather.ink,
          transition: 'width 1s ease, background-color .5s ease',
        })}
      />
    </Box>
  );
}
